import {loadCommands} from './commands';
import {loadComponent} from './component';
import {loadBlock} from './block';
import { hasRole, Role } from '../utils/user';

export const componentKey = 'data-bs-content';
export const componentType = 'tooltip';
export const componentCommandName = 'tooltip:open-modal';
export const svg = `<svg viewBox="0 0 24 24">
    <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11M11,9H13V7H11V9Z"></path>
</svg>`;

export function initTooltipComponent(editor, opts = {}) {
  const defaults = {
    toolbarBtnTooltipContent: {},
    modalTitle: 'Edit tooltip content',
    modalButtonLabel: 'Save',
    codeViewOptions: {
      styleActiveLine: true,
      lineWrapping: true,
    },
    placeholderContent: 'Add tooltip text or basic HTML (links, bold, lists).',
  };

  const options = {...defaults, ...opts};

  loadCommands(editor, options);
  loadComponent(editor, options);

  if (hasRole([Role.admin, Role.editor])) {
    loadBlock(editor, options);
  }
}
